<template>
  <div class="supply">
    <div class="hard">
      <div class="big-title">
        <p>解决传统电商平台的困境</p>
        <div class="line"></div>
        <div class="desc">
          流量获取、销售渠道、订单管理等一系列的问题严重阻滞平台发展
        </div>
      </div>
      <div class="hard-box">
        <div class="hard-item" v-for="item in hardArr" :key="item.id">
          <img :src="item.img" alt="" />
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="frame">
      <div class="big-title">
        <p>运营框架</p>
        <div class="line"></div>
        <div class="desc">
          流量获取、销售渠道、订单管理等一系列的问题严重阻滞平台发展
        </div>
      </div>
      <img src="../../static/images/solution/frame.png" alt="" />
    </div>
    <div class="system">
      <div class="big-title">
        <p>八大系统功能</p>
        <div class="line"></div>
        <div class="desc">
          站在用户立场，打造符合商家用户操作习惯与业务需求的电商系统对每一个功能都精雕细琢
        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="item in systemArr" :key="item.id">
          <img :src="item.img" alt="" />
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="value">
      <div class="big-title">
        <p>应用核心价值</p>
        <div class="line"></div>
        <div class="desc">
          站在用户立场，打造符合商家用户操作习惯与业务需求的电商系统对每一个功能都精雕细琢
        </div>
      </div>
      <img src="../../static/images/solution/value.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/gongyingshang2.png"),
          title: "供应商",
          desc: "缺乏流量获取渠道，供应链效率低下，库存信息传递慢",
        },
        {
          id: 1,
          img: require("../../static/images/solution/pingtai.png"),
          title: "平台",
          desc: "商品单一，运营成本高，需要解决发货、售后等一系列问题",
        },
        {
          id: 2,
          img: require("../../static/images/solution/dailishang.png"),
          title: "代理商",
          desc: "代理商利润稀薄，投资门槛高，渠道单一，获客成本高",
        },
        {
          id: 3,
          img: require("../../static/images/solution/mendian.png"),
          title: "门店",
          desc: "销售范围窄，没有更多的收益来源",
        },
        {
          id: 4,
          img: require("../../static/images/solution/pingtai.png"),
          title: "消费者",
          desc: "商品从“供应商-平台-消费者“，流程耗费时间长",
        },
      ],
      systemArr: [
        {
          id: 0,
          desc: "多种营销方式",
          img: require("../../static/images/solution/yingxiaofanmgshi.png"),
        },
        {
          id: 1,
          desc: "供应商管理",
          img: require("../../static/images/solution/gongyingshang.png"),
        },
        {
          id: 2,
          desc: "仓储管理",
          img: require("../../static/images/solution/cangchu.png"),
        },
        {
          id: 3,
          desc: "订单管理",
          img: require("../../static/images/solution/dingdan.png"),
        },
        {
          id: 4,
          desc: "商品管理",
          img: require("../../static/images/solution/shangpingguanli.png"),
        },
        {
          id: 5,
          desc: "会员管理",
          img: require("../../static/images/solution/huiyuan.png"),
        },
        {
          id: 6,
          desc: "营销管理",
          img: require("../../static/images/solution/yingxiao.png"),
        },
        {
          id: 7,
          desc: "物流管理",
          img: require("../../static/images/solution/wuliu.png"),
        },
      ],
    };
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 80px;
}

.hard {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .hard-box {
    display: flex;
  }

  .hard-item {
    box-sizing: border-box;
    padding: 0 40px;
    width: 262px;
    height: 302px;
    background: #F7F7F7;
    border-radius: 8px;
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h2 {
      margin-top: 20px;
      margin-bottom: 30px;
      font-size: 20px;
      font-weight: bold;
      color: #333333;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      text-align: center;
    }
  }
}

.frame, .value {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;
}

.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .system-box {
    display: flex;
    flex-wrap: wrap;
  }

  .system-item {
    width: 302px;
    height: 240px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin-right: 24px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      margin-top:40px;
    }
  }

  .system-item:hover {
    box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
  }
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 58px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/SolutionSupply.vue